export const mumbai = {
    name: 'Mumbai',
    interPoolContract: '0x46caF9ebEEa03ba564B71AacDfd65ffC9D0C0D42',
    interPoolTicketContract: '0x2e489Db34cB848fE5C9e73A01b683A6Edf747011',
    usdcContract: '0x9aa7fEc87CA69695Dd1f879567CcF49F3ba417E2',
    poolContract: '0x00858C026e7Ef3DA9a98725B20d99B3001255254'
    // enetContract: '0x50612995185cd0C339897eB92aeA9800929D76aE'
}

export const goerli = {
    name: 'Goerli',
    interPoolContract: '0x78F63a48B2532487e2afB85A939fB40F8FE9dd34',
    interPoolTicketContract: '0xD81e4a61FD6Bf066539dF6EA48bfaeAe847DCdA1',
    usdcContract: '0xA2025B15a1757311bfD68cb14eaeFCc237AF5b43',
    poolContract: '0x80A9c7C5F5BFD765A2dC3773dFF00d02Db8B34aE',
    // enetContract: '0x376d4A2cB540e01A7E233C9b721c04087511Ef3a'
}

export interface IFormInput {
    match1HomeScore: string,
    match1AwayScore: string,
    match2HomeScore: string,
    match2AwayScore: string,
    match3HomeScore: string,
    match3AwayScore: string,
    match4HomeScore: string,
    match4AwayScore: string,
    match5HomeScore: string,
    match5AwayScore: string,
    match6HomeScore: string,
    match6AwayScore: string,
    match7HomeScore: string,
    match7AwayScore: string,
    match8HomeScore: string,
    match8AwayScore: string,
    match9HomeScore: string,
    match9AwayScore: string,
    match10HomeScore: string,
    match10AwayScore: string,
    match11HomeScore: string,
    match11AwayScore: string,
    match12HomeScore: string,
    match12AwayScore: string,
    match13HomeScore: string,
    match13AwayScore: string,
    match14HomeScore: string,
    match14AwayScore: string,
    match15HomeScore: string,
    match15AwayScore: string,
    match16HomeScore: string,
    match16AwayScore: string,
    match17HomeScore: string,
    match17AwayScore: string,
    match18HomeScore: string,
    match18AwayScore: string,
    match19HomeScore: string,
    match19AwayScore: string,
    match20HomeScore: string,
    match20AwayScore: string,
    match21HomeScore: string,
    match21AwayScore: string,
    match22HomeScore: string,
    match22AwayScore: string,
    match23HomeScore: string,
    match23AwayScore: string,
    match24HomeScore: string,
    match24AwayScore: string,
    match25HomeScore: string,
    match25AwayScore: string,
    match26HomeScore: string,
    match26AwayScore: string,
    match27HomeScore: string,
    match27AwayScore: string,
    match28HomeScore: string,
    match28AwayScore: string,
    match29HomeScore: string,
    match29AwayScore: string,
    match30HomeScore: string,
    match30AwayScore: string,
    match31HomeScore: string,
    match31AwayScore: string,
    match32HomeScore: string,
    match32AwayScore: string,
    match33HomeScore: string,
    match33AwayScore: string,
    match34HomeScore: string,
    match34AwayScore: string,
    match35HomeScore: string,
    match35AwayScore: string,
    match36HomeScore: string,
    match36AwayScore: string,
    match37HomeScore: string,
    match37AwayScore: string,
    match38HomeScore: string,
    match38AwayScore: string,
    match39HomeScore: string,
    match39AwayScore: string,
    match40HomeScore: string,
    match40AwayScore: string,
    match41HomeScore: string,
    match41AwayScore: string,
    match42HomeScore: string,
    match42AwayScore: string,
    match43HomeScore: string,
    match43AwayScore: string,
    match44HomeScore: string,
    match44AwayScore: string,
    match45HomeScore: string,
    match45AwayScore: string,
    match46HomeScore: string,
    match46AwayScore: string,
    match47HomeScore: string,
    match47AwayScore: string,
    match48HomeScore: string,
    match48AwayScore: string,
}